import type { CodeSelectionAttachment } from '../components/ai-chat-content/type';

export const AI_CODE_SELECTION_CONTEXT_EVENT =
  'streamlain:ai-code-selection-context';

export const AI_CODE_SELECTION_PROPOSAL_EVENT =
  'streamlain:ai-code-selection-proposal';

export interface CodeSelectionContextEventDetail {
  readonly selection: CodeSelectionAttachment;
}

export interface CodeSelectionProposalEventDetail {
  readonly selectionId: string;
  readonly proposal: string;
  readonly language: CodeSelectionAttachment['language'];
  readonly sourceMessageId?: string;
}

export function dispatchCodeSelectionContext(
  selection: CodeSelectionAttachment
): void {
  window.dispatchEvent(
    new CustomEvent<CodeSelectionContextEventDetail>(
      AI_CODE_SELECTION_CONTEXT_EVENT,
      { detail: { selection } }
    )
  );
}

export function dispatchCodeSelectionProposal(
  detail: CodeSelectionProposalEventDetail
): void {
  window.dispatchEvent(
    new CustomEvent<CodeSelectionProposalEventDetail>(
      AI_CODE_SELECTION_PROPOSAL_EVENT,
      { detail }
    )
  );
}

export function isCodeSelectionContextEvent(
  event: Event
): event is CustomEvent<CodeSelectionContextEventDetail> {
  return (
    event instanceof CustomEvent &&
    event.type === AI_CODE_SELECTION_CONTEXT_EVENT &&
    typeof event.detail?.selection?.id === 'string'
  );
}

export function isCodeSelectionProposalEvent(
  event: Event
): event is CustomEvent<CodeSelectionProposalEventDetail> {
  return (
    event instanceof CustomEvent &&
    event.type === AI_CODE_SELECTION_PROPOSAL_EVENT &&
    typeof event.detail?.selectionId === 'string' &&
    typeof event.detail?.proposal === 'string'
  );
}
